import React, { useMemo } from 'react';
import { selectDeals } from '~/features/dashboard/store/selectors';
import { getUserData } from '~/store/user/selectors';
import { useSelector } from 'react-redux';
import { useParams, useRouteMatch } from 'react-router-dom';
import { Viewer } from '@grapecity/activereports-react';
import '@grapecity/activereports/styles/ar-js-ui.css';
import '@grapecity/activereports/styles/ar-js-viewer.css';
import report from './summary-pdf.json';
import { Core } from '@grapecity/activereports';
import { ActiveReportJSKey } from '~/features/dashboard';

export const DealPreview = () => {
    const { dealId } = useParams();

    const deals = useSelector(selectDeals);
    const userData: any = useSelector(getUserData);
    const deal: any = useMemo(() => deals.find(({ assetCode }) => assetCode === dealId), [dealId, deals]);
    const match = useRouteMatch<{ creatorId: string }>();
    const creatorId = useMemo(() => Number(match.params.creatorId), [match.params.creatorId]);

    const reportUri: any = JSON.parse(
        JSON.stringify(report)
            .replaceAll('[API]', String(process.env.REACT_APP_API))
            .replaceAll('[ASSET_CODE]', String(deal.assetCode))
            .replaceAll('[PROJECT_ID]', String(creatorId))
            .replaceAll('[TOKEN]', userData.data?.token)
    );

    Core.setLicenseKey(ActiveReportJSKey);

    return (
        <div style={{ height: '100%', width: '100%' }}>
            <Viewer report={{ Uri: reportUri }} />
        </div>
    );
};
